<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      Roadmap
      <div class="ml-auto">
        <i
          v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1"
          aria-hidden="true"
          @click="toggleHeaderMenu()"
        ></i>
        <i
          v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1"
          aria-hidden="true"
          @click="toggleHeaderMenu()"
        ></i>
      </div>
    </div>

    <saved-card-menu
      :entry-client-object="clientObject"
      :original-saved-cards="roadmapSavedCards"
      set-type="survey"
      view-type="menu"
    ></saved-card-menu>

    <div v-show="isByValueRoadmap" class="chart-app">
      <chart-criteria-roadmap
        ref="chartCriteria"
        :include-show-competitor-expectations="true"
        :include-show-pricing-power="true"
        showUseTTMAsStartDate="true"
        :show-display-type="false"
        :is-comparative="false"
        is-profile-page="true"
        fixed-display-type="value-roadmap"
        :roadmap-simulation-enabled="roadmapSimulationEnabled"
        :maximum-competitors="5"
        :content-list="pageContent"
        :view-navigation-options="roadmapViewOptions"
        :current-view="activeRoadmapView"
        view-navigation-label=""
        @select-view="selectRoadmapView"
        @select-value-profile="selectValueProfile"
        @simulate-roadmap="simulateRoadmap"
        @roadmap-criteria-changed="invalidateRoadmapSimulation"
        @reset-roadmap-v2="resetRoadmapV2"
        @prepare-roadmap-save="prepareRoadmapSave"
        @reset-client-chart="resetClientChart"
      ></chart-criteria-roadmap>

      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  :criteria-results-list="criteriaResultsList"
                  :criteria-results-company-list="criteriaResultsCompanyList"
                ></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <by-lift-roadmap
                ref="byLiftRoadmap"
                v-show="isByValueRoadmap && !generatingChart"
                :host-app="this"
                :chart-data="chartData"
                :content-list="pageContent"
                :input-display-initiatives="effortsLoaded"
                @set-value-roadmap-id="setValueMapDataId"
                @set-recommendations-data="handleRecommendationsData"
                @set-initatives="setInitiativesForNeeds"
                @set-effort-list="setEffortList"
                @display-initiatives="displayInitiativesForProfileTable"
                @focus-changed="markFocusChanged"
              ></by-lift-roadmap>
            </div>
          </div>
        </div>
      </div>
    </div>

    <competitive-trends
      v-if="isRoadmapExplore"
      :key="`${saveClientChartIdFromProfile}-${needTypeFromProfile}-${needNumberFromProfile}`"
      embedded-in-roadmap
      :auto-generate-chart-from-profile="exploreFromProfile"
      :save-client-chart-id-from-profile="saveClientChartIdFromProfile"
      :need-type-from-profile="needTypeFromProfile"
      :need-number-from-profile="needNumberFromProfile"
      :auto-generate-chart="isExploreSavedCard ? autoGenerateChart : false"
      :save-client-chart-id="isExploreSavedCard ? saveClientChartId : 0"
      :view-navigation-options="roadmapViewOptions"
      :current-roadmap-view="activeRoadmapView"
      @select-roadmap-view="selectRoadmapView"
    />

    <predictive-analytics
      v-if="isRoadmapPredictive"
      embedded-in-roadmap
      :auto-generate-chart="isPredictiveSavedCard ? autoGenerateChart : false"
      :save-client-chart-id="isPredictiveSavedCard ? saveClientChartId : 0"
      :view-navigation-options="roadmapViewOptions"
      :current-roadmap-view="activeRoadmapView"
      @select-roadmap-view="selectRoadmapView"
    />

    <vue-modal v-if="isByValueRoadmap" ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart
        button-label="Save as Card"
        chart-title="Roadmap"
        is-roadmap
        :initial-client-chart="clientChart"
        @save="updateClientCharts"
        @closeModal="closeModal('save-chart-confirmation')"
      ></save-chart>
    </vue-modal>

    <roadmap-initiatives-modal
      ref="roadMapInitiativesForProfileTable"
      modal-name="road-map-initiatives-roadmap"
      :input-value-road-map-id="selectedValueRoadMapId"
      :client-chart-object="clientChart"
      :roadmap-chart-data="this.recommendationsData"
      :initiatives-survey-group-id="initiativesSurveyGroupId"
      @refresh-initiative="refreshInitiativesTable"
    />
    <explore-navigation-modal
      ref="exploreNavigationModal"
      modal-name="explore-navigation-modal"
      modal-id="explore-navigation-modal"
    />
  </div>
</template>

<script>
import AdminService from "../../services/admin.service";
import AlertService from "../../services/alert.service";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import MoatService from "../../services/moat.service";
import ValueGroupMap from "../../services/chart/value.group.map.service";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ByLiftRoadmap from "./type/ByLiftRoadmap.vue";
import CompetitiveTrends from "./CompetitiveTrends.vue";
import PredictiveAnalytics from "./PredictiveAnalytics.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import RoadmapInitiativesModal from "../../modals/RoadmapInitiativesModal.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";
import ValueGroupMapService from "../../services/chart/value.group.map.service";
import ClientSettingsService from "../../services/client.settings.service";
import ContentService from "../../services/content.service";
import ChartCriteriaRoadmap from "../../components/chart/ChartCriteriaRoadmap.vue";

export default {
  name: "Roadmap",
  mixins: [ChartCompanyMixins],
  components: {
    ChartCriteriaRoadmap,
    ByLiftRoadmap,
    CompetitiveTrends,
    PredictiveAnalytics,
    ChartDisplaySkeleton,
    SaveChart,
    RoadmapInitiativesModal,
    ExploreNavigationModal
  },
  data() {
    return {
      chartData: [],
      activeRoadmapView: "value-roadmap",
      isByValueRoadmap: true,
      displayProfileStrengthLegend: false,
      selectedValueRoadMapId: 0,
      selectedValueProfileCard: null,
      roadmapSimulationEnabled: false,
      editedFocusRoadmaps: {},
      roadmapCriteriaRevision: 0,
      roadmapRequestRevision: -1,
      roadmapViewOptions: [
        { name: "Lift Map", value: "value-roadmap" },
        { name: "Explore", value: "roadmap-explore" },
        { name: "Predictive", value: "roadmap-predictive" }
      ],
      effortLoadId: 0,
      effortsLoaded: false,
      focusAreaEfforts: [],
      otherAreaEfforts: [],
      defaultEffortSets: [],
      selectedInitiativeContext: null,
      initiativesSurveyGroupId: 0,
      moatInitiatives: [],
      sectorIdList: [],
    };
  },
  computed: {
    isRoadmapExplore() {
      return this.activeRoadmapView == "roadmap-explore";
    },
    isRoadmapPredictive() {
      return this.activeRoadmapView == "roadmap-predictive";
    },
    selectedSavedCard() {
      return this.clientChartsBySurvey.find(card => card.clientChartId == this.saveClientChartId);
    },
    isExploreSavedCard() {
      return this.selectedSavedCard != null && this.selectedSavedCard.displayType == "roadmap-explore";
    },
    isPredictiveSavedCard() {
      return this.selectedSavedCard != null && this.selectedSavedCard.displayType == "roadmap-predictive";
    },
    roadmapSavedCards() {
      return this.clientChartsBySurvey.filter(card => card.chartTypeId == 29);
    }
  },
  created() {
    ContentService.getPageContent("Roadmap", this.getPageContentByRoadmapCallBack, this);
    this.chart = ChartService.getChartAttributes("Roadmap");
  },
  mounted() {
    if (this.isExploreSavedCard || this.isPredictiveSavedCard) {
      this.selectRoadmapView(this.selectedSavedCard.displayType);
    }
    this.getSurveyGroupDataForInitiatives();
  },
  beforeUnmount() {
    this.effortLoadId++;
  },
  methods: {
    getPageContentByRoadmapCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContent = response.data.data;
      }
    },
    selectRoadmapView(displayType) {
      this.activeRoadmapView = displayType;
      this.isByValueRoadmap = displayType == "value-roadmap";
    },
    selectValueProfile(savedCard) {
      this.selectedValueProfileCard = savedCard;
      this.roadmapSimulationEnabled = false;
    },
    simulateRoadmap() {
      if (this.roadmapSimulationEnabled) {
        if (this.editedFocusRoadmaps[this.selectedValueRoadMapId]) {
          const roadmapId = this.selectedValueRoadMapId;
          const criteriaRevision = this.roadmapCriteriaRevision;
          AlertService.showConfirmationMessage(() => {
            if (this.roadmapSimulationEnabled && this.selectedValueRoadMapId === roadmapId && this.roadmapCriteriaRevision === criteriaRevision) {
              this.$refs.chartCriteria.runChart(true);
            }
          }, "Simulate Confirmation", "Simulate will replace your Focus selections with the system's Top 5 selections. Continue?");
          return;
        }
        this.$refs.chartCriteria.runChart(true);
      }
    },
    markFocusChanged(valueRoadMapId) {
      this.editedFocusRoadmaps = { ...this.editedFocusRoadmaps, [valueRoadMapId]: true };
    },
    invalidateRoadmapSimulation() {
      this.roadmapCriteriaRevision++;
      this.roadmapSimulationEnabled = false;
    },
    resetRoadmapV2() {
      this.selectedValueProfileCard = null;
      this.roadmapSimulationEnabled = false;
      this.chartData = [];
      this.resetClientChart();
    },
    prepareRoadmapSave() {
      const chartCriteria = this.$refs.chartCriteria;
      const periodName = chartCriteria.getPeriodName(chartCriteria.period);
      const profileName = this.selectedValueProfileCard ? this.selectedValueProfileCard.name : "Value Profile";
      const params = chartCriteria.buildUrlParams(this.clientId);
      if (this.selectedValueRoadMapId > 0) {
        params.set("valueRoadMapId", this.selectedValueRoadMapId);
      } else {
        params.delete("valueRoadMapId");
      }
      const roadmapInitiativeSequence = this.getRoadmapInitiativeSequenceForSave();
      if (roadmapInitiativeSequence.length) {
        params.set("roadmap_initiative_sequence", JSON.stringify(roadmapInitiativeSequence));
      }
      this.clientChart.criteria = params.toString();
      this.clientChart.clientTimePeriodId = chartCriteria.period;
      this.clientChart.useCurrentTimePeriod = "N";
      this.clientChart.displayType = "value-roadmap";
      if (!this.clientChart.name || !this.clientChart.name.trim() || this.clientChart.clientChartId == 0) {
        this.clientChart.name = `${profileName} ${periodName}`.trim();
      }
    },
    getRoadmapInitiativeSequenceForSave() {
      const byLiftRoadmap = this.$refs.byLiftRoadmap;
      if (byLiftRoadmap && typeof byLiftRoadmap.getRoadmapInitiativeSequenceForSave == "function") {
        return byLiftRoadmap.getRoadmapInitiativeSequenceForSave();
      }
      return [];
    },
    displayMainChart() {
      this.roadmapSimulationEnabled = false;
      this.roadmapRequestRevision = this.roadmapCriteriaRevision;
      if (this.isExploreSavedCard || this.isPredictiveSavedCard) {
        this.selectRoadmapView(this.selectedSavedCard.displayType);
        return;
      }
      return ChartCompanyMixins.methods.displayMainChart.call(this);
    },
    closeModal(name) {
      if (this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    setValueMapDataId(valueRoadMapId) {
      this.selectedValueRoadMapId = valueRoadMapId;
    },
    async displayChartCallback(response) {
      this.displayChartCriteriaResults = false;
      try {
        this.$root.processServerResponse();
        const roadmapCriteria = this.$refs.chartCriteria.roadmapCriteriaResults || [];
        if (response.data[0]) {
          const names = new Set([...roadmapCriteria.map(criteria => criteria.name), "Value Profile Saved Card"]);
          const parameters = new Set(roadmapCriteria.map(criteria => criteria.parameterName));
          response.data[0].criteriaList = [
            ...(response.data[0].criteriaList || []).filter(criteria => !names.has(criteria.name) && !parameters.has(criteria.parameterName)),
            ...roadmapCriteria
          ];
        }
        this.setValueMapDataId(response.data[0]?.otherData?.valueRoadMapId || 0);
        if (response.data[0]?.otherData?.focusAreasReplaced) {
          this.editedFocusRoadmaps = { ...this.editedFocusRoadmaps, [this.selectedValueRoadMapId]: false };
        }
        await this.loadInitiativeData();
        this.generatingChart = false;
        this.isByValueRoadmap = true;
        this.chartData = response.data;
        this.roadmapSimulationEnabled = Array.isArray(response.data) && !!response.data[0] &&
          this.roadmapRequestRevision === this.roadmapCriteriaRevision;
      } catch (err) {
        ErrorService.processException("Roadmap.displayChartCallback", err, "chart", this);
      }
    },
    loadInitiativeData() {
      this.effortsLoaded = false;
      this.setEffortSet([], []);
      this.defaultEffortSets = [];

      const criteria = this.$refs.chartCriteria;
      const surveyCode = this.surveyCode || (this.survey && this.survey.surveyCode);
      const clientChart = this.clientChart || {};
      const period = criteria.period || clientChart.clientTimePeriodId;
      const valueProfileClientChartId = criteria.valueProfileClientChartId;
      if (!surveyCode || !period || !valueProfileClientChartId) return;

      return new Promise(resolve => {
        ValueGroupMapService.getValueRoadMapSetupBySurveyCode(
        surveyCode, clientChart.clientChartId || 0, valueProfileClientChartId, period,
        criteria.roadmapV2 ? "" : criteria.surveyGroup || "",
        criteria.roadmapV2 ? "N" : criteria.useEqualWeight || "N",
        response => {
          this.loadInitiativeDataCallback(response);
          resolve(); 
        }
        , this, this.selectedValueRoadMapId || 0);
      });
    },
    loadInitiativeDataCallback(response) {//alert('loadInitiativeDataCallback');
      if (response.data.statusCode != 200) {
        AdminService.displayErrorMessage({ text: response.data.message });
        return;
      }
      const data = response.data.data || {};
      this.defaultEffortSets = Array.isArray(data.defaultEffortSets) ? data.defaultEffortSets : [];
      this.valueRoadMapId = data.valueRoadMapId || 0;
      if (!this.isDefaultTypeEmpty(data.focusAreaEfforts, data.otherAreaEfforts)) {
        this.setEffortSet(data.focusAreaEfforts, data.otherAreaEfforts);
      } else {
        const defaultSet = this.defaultEffortSets.find(set => !this.isDefaultTypeEmpty(set.focusAreaEfforts, set.otherAreaEfforts));
        if (defaultSet) this.switchToDefault(defaultSet.name);
        else this.setEffortSet([], []);
      }
      this.effortsLoaded = true;
    },
    setEffortSet(focusAreaEfforts, otherAreaEfforts) {
      this.focusAreaEfforts = JSON.parse(JSON.stringify(Array.isArray(focusAreaEfforts) ? focusAreaEfforts : []));
      this.otherAreaEfforts = JSON.parse(JSON.stringify(Array.isArray(otherAreaEfforts) ? otherAreaEfforts : []));
    },
    isDefaultTypeEmpty(focusAreaEfforts, otherAreaEfforts) {
      return !(Array.isArray(focusAreaEfforts) && focusAreaEfforts.length) &&
        !(Array.isArray(otherAreaEfforts) && otherAreaEfforts.length);
    },
    switchToDefault(defaultTypeName) {
      const defaultSet = this.defaultEffortSets.find(set => set.name === defaultTypeName);
      if (defaultSet && !this.isDefaultTypeEmpty(defaultSet.focusAreaEfforts, defaultSet.otherAreaEfforts)) {
        this.setEffortSet(defaultSet.focusAreaEfforts, defaultSet.otherAreaEfforts);
      }
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    async displayInitiativesForProfileTable(element) {
      let needName = element.needName;
      let needType = element.needType;
      let valueRoadMapId = this.selectedValueRoadMapId;

      let modal = this.$refs.roadMapInitiativesForProfileTable;
      modal.$data.title = needName;
      modal.$data.needName = needName;
      modal.$data.needType = needType;
      modal.$data.valueRoadMapId = valueRoadMapId;
      modal.$data.sequenceNumber = element.sequenceNumber;
      const effortList = [
        ...this.focusAreaEfforts,
        ...this.otherAreaEfforts
      ];
      const matchingEffort = effortList.find(e =>
        Number(e.needNumber) === Number(element.sequenceNumber) &&
        String(e.needType).toLowerCase() === String(element.needType).toLowerCase()
      ) || { needNumber: element.sequenceNumber, initiative: "", description: "", moatDescription: {} };
      this.selectedInitiativeContext = {
        needNumber: matchingEffort.needNumber,
        needType: matchingEffort.needType || needType
      };
      modal.$data.needNumber = matchingEffort.needNumber;
      modal.$data.moatName = matchingEffort.moatName;
      // Use single selected metric name only
      modal.$data.metricGroupRelationshipId = matchingEffort.needQuestionMetricGroupId || 0;
      const metricRelationship = matchingEffort.needQuestionMetricName || 'None Selected';
      modal.$data.metricRelationship = metricRelationship;
      modal.$data.selectedInitiative = { initiative: matchingEffort.initiative, description: matchingEffort.description };
      modal.$data.initiatives = JSON.parse(JSON.stringify(matchingEffort || []));
      // modal.$data.moatInitiatives = JSON.parse(JSON.stringify(this.moatInitiatives || []));
      modal.$data.moatDescription = JSON.parse(JSON.stringify(matchingEffort.moatDescription));
      modal.$data.displayInitiatives = true;
      modal.$data.showCustomInitiative = true;
      modal.$data.addOrSaveInitiative = "Save";
      modal.$data.saveEnabled = true;
      modal.loadData();
      this.$modal.show("road-map-initiatives-roadmap");
    },
    refreshInitiativesTable(initiative, description) {
      if (!this.selectedInitiativeContext) return;
      this.updateInitiativeEffort(this.focusAreaEfforts, initiative, description);
      this.updateInitiativeEffort(this.otherAreaEfforts, initiative, description);
      (this.defaultEffortSets || []).forEach(effortSet => {
        this.updateInitiativeEffort(effortSet.focusAreaEfforts, initiative, description);
        this.updateInitiativeEffort(effortSet.otherAreaEfforts, initiative, description);
      });
      this.$nextTick(() => {
        const byLiftRoadmap = this.$refs.byLiftRoadmap;
        const initiativesTable = byLiftRoadmap && byLiftRoadmap.$refs.roadMapInitiatives;
        if (initiativesTable) {
          initiativesTable.loadData();
        }
      });
      this.selectedInitiativeContext = null;
    },
    updateInitiativeEffort(effortList, initiative, description) {
      if (!Array.isArray(effortList) || !this.selectedInitiativeContext) return;
      const effort = effortList.find(e =>
        Number(e.needNumber) === Number(this.selectedInitiativeContext.needNumber) &&
        String(e.needType).toLowerCase() === String(this.selectedInitiativeContext.needType).toLowerCase()
      );
      if (effort) {
        effort.initiative = initiative || "";
        effort.description = description || "";
      }
    },
    getSurveyGroupDataForInitiatives() {
      if (this.clientCode == "") {
        return;
      }
      this.initiativesSurveyGroupId = 0;
      ClientSettingsService.getClientSettings(
        this.clientCode,
        response => {
          if (response.data.statusCode == 200) {
            const clientSettings = ClientSettingsService.parseClientSettings(response.data.data);
            this.initiativesSurveyGroupId = Number(clientSettings.initiativesSurveyGroupId) || 0;
          } 
        },
        this
      );
    },
  },
  props: {
    exploreFromProfile: { type: Boolean, default: false },
    saveClientChartIdFromProfile: { type: Number, default: 0 },
    needTypeFromProfile: { type: String, default: "" },
    needNumberFromProfile: { type: Number, default: 0 }
  },
  watch: {
    exploreFromProfile: {
      immediate: true,
      handler(value) {
        if (value) this.selectRoadmapView("roadmap-explore");
      }
    },
    selectedSavedCard(savedCard) {
      if (savedCard != null) {
        const roadmapViews = ["roadmap-explore", "roadmap-predictive"];
        this.selectRoadmapView(roadmapViews.includes(savedCard.displayType) ? savedCard.displayType : "value-roadmap");
      }
    },
    clientCode() {
      this.getSurveyGroupDataForInitiatives();
    }
  }
};
</script>
